import React, {useEffect, useState} from 'react';
import NovoDestaque from '../forms/destaques/NovoDestaque';
import {CircularProgress} from '@mui/material';
import axios from "Admin/state/axios";
import Toast from 'Admin/components/Toast';
const appUrl = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem('token');


function Destaques() {
  const [ destaques, setDestaques] = useState([]);
  const [ isLoading, setIsLoading] = useState(true);
  const [ removerLoading, setRemoverLoading] = useState(false);
  const [ refresh, setRefresh] = useState(true);
  const [msg, setMsg] = useState(false);
  const handleMsg = (msg) =>{
    setMsg(msg)
    setTimeout(() => {
      setMsg(null);
  }, 5000);
  }

  const DestaqueItem = ({item}) =>{

    async function remover (id) {
      setRemoverLoading({
        status:true, 
        item:id
      })

      const response = await axios({
        url: `rmv-destaques/${id}`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setRemoverLoading({
        status:false, 
        item:0
      })
      handleMsg(response.data.message);
      setRefresh(true);
    }
    
  return(
    <div className='flex flex-row justify-between items-center align-middle m-1 text-[10pt] p-2 rounded-md border-[1px]'> 
      <div className='flex justify-center items-center gap-2'>
      <img className='w-[80px] rounded-md m-1' src={`${appUrl}/${item.produto.imagens[0].imagem}`}/>
      <p className='font-semibold p-1'>{item.produto.nome}</p>
      </div>
    <button onClick={()=>remover(item.id)} className={` bg-red-400 hover:bg-red-500 admin-button`}> {removerLoading.status === true && removerLoading.item === item.id ? (<CircularProgress color="success" size={22} style={{padding:2}}/>) : ('Remover Item')}</button>
    </div>
  )
  }

  useEffect(() => {
    async function getDestaques() {
      try {
        const response = await axios({
          url: "destaques",
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
        setDestaques(response.data);

        setIsLoading(false);
      } catch (err) {
      }
    }
    getDestaques();
  }, [msg]);

  useEffect(() => {
    async function getDestaques() {
      try {
        setIsLoading(true); // Iniciar carregamento
        const response = await axios({
          url: "destaques",
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
        setDestaques(response.data);
        setRefresh(false); // Resetar estado de refresh
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false); // Encerrar carregamento
      }
    }
  
    if (refresh) {
      getDestaques();
    }
  }, [refresh]);

  return ( 
  <div className='p-2 flex flex-col gap-2 text-[10pt]' > 
  <div>
    <h3 className='text-[14pt]'>Painel de Destaques</h3>
    <p className='text-[9pt] -mt-2'>Destaques seus produtos em sua loja.</p>
    <hr/>
  <br/>
  {!isLoading ? (    
  <>
    <h3 className='text-[12pt]' variant={'h6'}>Produtos em Promoção:  </h3>
        {destaques.promocao && destaques.promocao.length > 0 ? destaques.promocao.map((item) => (        
          <div>          
          <DestaqueItem item={item} key={item.id}/>
          </div>  
          )) : <p>Nenhum produto cadastrado em promoção</p>}
    <br/>
    <h3 className='text-[12pt]' variant={'h6'}>Produtos em Novidades:  </h3>
        {destaques.novidade && destaques.novidade.length > 0 ? destaques.novidade.map((item) => (        
            <div>
            <DestaqueItem item={item} key={item.id}/>
            </div>  
          )) : <p>Nenhum produto cadastrado em novidades</p>}
    <br/>
    <h3 className='text-[12pt]' variant={'h6'}>Produtos em Destaque:  </h3>
        {destaques.destaque && destaques.destaque.length > 0 ? destaques.destaque.map((item) => (
          <div>
            
            <DestaqueItem item={item} key={item.id}/>
          </div>        
          )) : null}
    </>) : null}
    </div>
    {msg ? 
      <Toast msg={msg} type='info'/>
    : null}
    <br/>
    <div>
    <NovoDestaque setRefresh={setRefresh} />  
    </div>
</div>);
}

export default Destaques;